/**
 * Web Component for handling variant-specific ingredients display
 * Shows/hides pre-rendered variant content based on selected variant
 */

if (typeof window.customElements !== 'undefined' && !window.customElements.get('variant-ingredients')) {
  class VariantIngredients extends HTMLElement {
    constructor() {
      super();
      this.sectionId = this.dataset.sectionId;
      this.handleVariantChange = this.handleVariantChange.bind(this);
    }

    connectedCallback() {
      // Subscribe to variant change events
      if (typeof window.pubSub !== 'undefined' && typeof window.PUB_SUB_EVENTS !== 'undefined') {
        window.pubSub.subscribe(
          window.PUB_SUB_EVENTS.variantChange,
          this.handleVariantChange
        );
      }

      // Show the initial variant's content
      this.showInitialVariant();
    }

    disconnectedCallback() {
      // Unsubscribe when component is removed
      if (typeof window.pubSub !== 'undefined' && typeof window.PUB_SUB_EVENTS !== 'undefined') {
        window.pubSub.unsubscribe(
          window.PUB_SUB_EVENTS.variantChange,
          this.handleVariantChange
        );
      }
    }

    /**
     * Show the initial variant content (selected or first available)
     */
    showInitialVariant() {
      const initialVariantId = this.dataset.initialVariantId;
      if (initialVariantId) {
        this.showVariantContent(initialVariantId);
      }
    }

    /**
     * Handle variant change event
     */
    handleVariantChange(event) {
      const { variant, sectionId } = event.data || {};

      // Only handle events for this section
      if (sectionId !== this.sectionId || !variant) return;

      this.showVariantContent(variant.id);
    }

    /**
     * Show content for specific variant, hide others
     */
    showVariantContent(variantId) {
      const allVariantContents = this.querySelectorAll('[data-variant-id]');
      const accordionBlock = this.closest('.product-accordion');

      let hasContent = false;

      allVariantContents.forEach((content) => {
        if (content.dataset.variantId === String(variantId)) {
          // Show this variant's content
          content.style.display = '';
          
          // Check if this variant has actual content
          if (content.textContent.trim() !== '') {
            hasContent = true;
          }
        } else {
          // Hide other variants' content
          content.style.display = 'none';
        }
      });

      // Show/hide the entire accordion block based on whether there's content
      if (accordionBlock) {
        if (hasContent) {
          accordionBlock.style.display = '';
        } else {
          accordionBlock.style.display = 'none';
        }
      }
    }
  }

  window.customElements.define('variant-ingredients', VariantIngredients);
}
